// extracted by mini-css-extract-plugin
module.exports = {"schedule":"Schedule_schedule__3Fd00","day":"Schedule_day__kOZDk"};